import * as React from 'react';
import EmployeesComboboxMI, { OptionType, IEmployeesFilterParams } from './../EmployeesComboboxMI';
import { DialogContent, Dialog, DialogTitle, DialogActions, Button } from '@material-ui/core';
import strings from './../../utils/StringManager';
import { IResourceInputConfig } from './Models';
import { createGridConfig } from './GridResourcesConfig';
import { defaultEmployeeGrid } from './RenderMultiEmployeesInput';

interface IProps {
	value: OptionType,
	onChange: (value: OptionType) => void,
	filters: IEmployeesFilterParams,
	personLabel: string,
	employeesConfig?: IResourceInputConfig,
}

export default function EditCurrentEmployee(props: IProps) {
	
	const [open, setOpen] = React.useState(false);
	const [selectedEmploye, setSelectedEmploye] = React.useState<OptionType>(props.value);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleAccept = () => {
		setOpen(false);
		if (!selectedEmploye)
			props.onChange(null);
		else
			props.onChange(selectedEmploye);
	};

	const grid = createGridConfig("selectEmployee", props.employeesConfig.grid, defaultEmployeeGrid);

	return <>
		<button type="button" onClick={handleClickOpen} className="qd-btn qd-btn-default" style={{ marginLeft: "7px" }}>
			{strings.get("edit")}
		</button>
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby="edit-current-employee-dialog-title"
			aria-describedby="edit-current-employee-dialog-description"
			disableBackdropClick={true}
		>
			<DialogTitle id="edit-current-employee-dialog-title">{strings.get("select")}</DialogTitle>
			<DialogContent>
				<div className="edit-input-row">
					<dl>
						<dt><label>{props.personLabel}:</label></dt>
						<dd style={{ width: "400px" }}>
							<EmployeesComboboxMI
								filters={props.filters}
								value={selectedEmploye}
								onSelect={(v) => setSelectedEmploye(v)}
								grid={grid}
							/>
						</dd>
					</dl>
				</div>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="default">
					{strings.get("cancel")}
				</Button>
				<Button onClick={handleAccept} color="primary" autoFocus variant="contained">
					{strings.get("save")}
				</Button>
			</DialogActions>
		</Dialog>
	</>
}